import { render } from "./strategic-connections.vue?vue&type=template&id=41ef0b95&lang=pug"
import script from "./strategic-connections.vue?vue&type=script&lang=js"
export * from "./strategic-connections.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__